export default "__VITE_ASSET__cc0e6467__"